import { render, staticRenderFns } from "./adminuserAduit.vue?vue&type=template&id=c3872acc&scoped=true"
import script from "./adminuserAduit.vue?vue&type=script&lang=js"
export * from "./adminuserAduit.vue?vue&type=script&lang=js"
import style0 from "./adminuserAduit.vue?vue&type=style&index=0&id=c3872acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3872acc",
  null
  
)

export default component.exports